import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id FAE0DF65-BA66-4F45-B246-35EFD1DF6FF2
 * name moon-waxing-crescent
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moon-waxing-crescent.svg
 * tags
 * - Weather 
 */
export const MoonWaxingCrescentIcon = createSvgIcon(<><path d="M12 2A9.91 9.91 0 0 0 9 2.46A10 10 0 0 1 9 21.54A10 10 0 1 0 12 2Z" /></>, 'MoonWaxingCrescentIcon');
export default MoonWaxingCrescentIcon